<template>
  <main>
    <nav-title class="pb-2" :title="'FAQ'" :color="true" />
    <div class="p-3">
      <div class="search-container py-4 px-sm-3 px-md-5">
        <faq-search @onSearch="handleSearch" />
      </div>
      <faq-topics :topics="getFaqsTopics" @onTopicClick="handleTopicClick" />
      <faq-posts :posts="getFaqsPosts" @onClickTopicTag="handleTopicClick" />
    </div>
  </main>
</template>
<script>
import store from '@/store';
import navTitle from '@/components/general/navTitle.vue';
import FaqSearch from '@/components/faq/FaqSearch.vue';
import FaqTopics from '@/components/faq/FaqTopics.vue';
import FaqPosts from '@/components/faq/FaqPosts.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    navTitle,
    FaqSearch,
    FaqTopics,
    FaqPosts,
  },
  async beforeRouteEnter(to, from, next) {
    try {
      await store.dispatch('general/fetchFaqsPost', { query: {} });
      await store.dispatch('general/fetchFaqsTopics');
    } catch (error) {
      console.error(error);
    } finally {
      next();
    }
  },
  computed: {
    ...mapGetters('general', ['getFaqsPosts', 'getFaqsTopics']),
  },
  methods: {
    ...mapActions('general', ['fetchFaqsPost']),
    async handleSearch({ text }) {
      try {
        const query = { keywords: text };
        await this.fetchFaqsPost({ query });
      } catch (error) {
        console.error(error);
      }
    },
    async handleTopicClick(topicId = "") {
      try {
        let topic_id = topicId;
        if (typeof topicId === 'object') {
          topic_id = this.getFaqsTopics.find((topic) => topic.name === topicId.topic)['id'];
        }
        const query = { topic_id };
        await this.fetchFaqsPost({ query });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
